<main>
  <!--Breadcrumbs-->
  <div class="breadcrumbs-container flex gap-1 mt-10 px-29">
    <span class="root text-regular text-charcoal-800" routerLink="/home">
      Homepage
      <span class="text-regular text-charcoal-800">/</span>
    </span>
    <img
      routerLink="/home"
      class="arrow-left-container"
      src="assets/icons/arrow-left.svg"
      alt="arrow-left"
    >
    <span class="text-regular" [ngStyle]="{ color: breadcrumbColor }">{{ breadcrumb }}</span>
  </div>

  <!--Seção do hero-->
  <section class="hero-section flex gap-16 items-center justify-between px-29">
    <div class="hero-text-container w-1/2 flex flex-col gap-4">
      <div class="main-text-container flex items-center gap-4">
        <img [src]="iconeHero" alt="hero-icon">
        <div class="flex flex-col items-start justify-center">
          <span class="text-heading-md text-regular" [ngStyle]="{ color: corSubtituloHero }">{{ subtituloHero }}</span>
          <h1 class="text-display-lg text-bold m-0" [ngStyle]="{ color: corTituloHero }">
            {{ tituloHero }}
          </h1>
        </div>
      </div>

      <p class="text-regular" style="color: #444;" *ngIf="featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')" [innerHTML]="descricaoHero"></p>
      <p class="text-regular" style="color: #444;" *ngIf="!featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')" >{{ descricaoHero }}</p>

      <!--Botão de acesso à simulação-->
      <button
        [routerLink]="linkBotaoHero"
        class="access-simulation-button px-4 py-3 bg-transparent border-0 flex items-center gap-2"
        [ngStyle]="{ background: corBotaoHero }"
      >
        <span class="text-body-xlg text-regular" [ngStyle]="{ color: corTextoBotaoHero }">
          {{ textoBotaoHero }}
        </span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" [style.color]="corSetaHero">
          <path d="M10 16L16 10M16 10L10 4M16 10L4 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!--Imagens-->
    <div class="hero-image-container flex w-1/2 items-center justify-center">
      <div class="hero-image-container">
        <img class="hero-image" [src]="imagemHero" alt="hero-image">
        <img [src]="backgroundHero" alt="background-circles">
      </div>
    </div>
  </section>

  <!--Seção de ícones com texto -->
  <section class="information-section mt-16 px-29">
    <div class="information-icons-container flex gap-16 items-center justify-center" *ngIf="infoIcone?.length">
      <div *ngFor="let icon of infoIcone" class="w-64 flex flex-col gap-4 items-center justify-center">
        <img [src]="icon.img" alt="info-icon">
        <p class="m-0 text-body-xlg text-regular" [ngStyle]="{ color: icon.color }" style="text-align: center;">
          {{ icon.text }}
        </p>
      </div>
    </div>

    <!--Seção de texto informativo-->
    <div class="information-text-container flex gap-16 mt-16" *ngIf="infoTexto?.length">
      <ng-container *ngFor="let info of infoTexto">
        <p class="text-body-xlg text-regular flex-1" [ngStyle]="{ color: info.color }" [innerHTML]="info.html" style="text-align: justify;"></p>
      </ng-container>
    </div>
  </section>

  <!--Seção texto e CTA -->
  <section
    class="simulation-section mt-16 flex items-center justify-center px-29"
    *ngIf="tituloCta || textoBotaoCta"
  >
    <div class="simulation-text-container w-1/2 flex flex-col gap-4 items-start justify-center">
      <h1 class="text-display-md text-bold" style="color: #444;" *ngIf="tituloCta">
        {{ tituloCta }}
      </h1>

      <button
        [routerLink]="linkBotaoCta"
        class="start-simulation-button px-4 py-3 border-0 rounded-xs flex items-center gap-2"
        [ngStyle]="{ background: corBotaoCta }"
        *ngIf="textoBotaoCta"
      >
        <span class="text-body-xlg text-regular" [ngStyle]="{ color: corTextoBotaoCta }">
          {{ textoBotaoCta }}
        </span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" [style.color]="corSetaCta">
          <path d="M10 16L16 10M16 10L10 4M16 10L4 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </section>

  <div class="mb-30"></div>
</main>
